import React from 'react';
import styled from '@emotion/styled';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
`;

const ModalContent = styled.div`
  background: ${props => props.theme.colors.background};
  max-width: ${props => props.$maxWidth || '95vw'};
  width: ${props => (props.$maxWidth ? '100%' : 'auto')};
  max-height: 95vh;
  border-radius: 0;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 1001;
  
  &:hover {
    color: ${props => props.theme.colors.primary};
  }
`;

const Modal = ({ isOpen, onClose, children, maxWidth, closeOnOverlayClick = true }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={closeOnOverlayClick ? onClose : undefined}>
      <ModalContent onClick={e => e.stopPropagation()} $maxWidth={maxWidth}>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        {children}
      </ModalContent>
    </ModalOverlay>
  );
};

export default Modal;